<template>
	<div
		v-if="data"
		class="absolute h-7 flex items-center justify-center"
		:class="`${data.placement} ${data.color} ${data.textSize} ${isImage ? 'w-10' : `min-w-10 ${data.background}`} ${position}`"
	>
		<span v-show="!isImage">{{ data.text }}</span>
		<img
			v-if="isImage"
			:src="data.image.filename"
			:alt="data.image.alt"
			class="h-auto w-auto aspect-1/1 object-cover"
		/>
	</div>
</template>

<script setup lang="ts">
import type { ApplicationFlag } from "~/types/storyblok/storyblok";

interface Props {
	data?: ApplicationFlag;
	position: string;
}
const { data } = defineProps<Props>();

const isImage = computed(() => data.image?.filename);
</script>
